import { Link } from "react-router-dom";
import { Phone, MapPin, Clock } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, ADDRESS, MAP_URL, fileUrl } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";

export const Footer = () => {
  const { settings } = useSettings() || {};
  const logo = settings?.logo_image ? fileUrl(settings.logo_image) : null;
  return (
    <footer className="bg-slate-900 text-slate-300 mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid gap-8 sm:grid-cols-3">
        <div>
          {logo ? (
            <img src={logo} alt="Erskine Auto logo" className="h-12 w-auto max-w-[200px] object-contain mb-3 bg-white/5 rounded p-1" data-testid="footer-logo-image" />
          ) : (
            <h3 className="font-display font-extrabold text-white text-xl mb-2">Erskine Auto</h3>
          )}
          <p className="text-sm text-slate-400 leading-relaxed">
            Quality used vehicles in Oak Bay, New Brunswick.
          </p>
        </div>
        <div className="space-y-3 text-sm">
          <a href={`tel:${PHONE_TEL}`} className="flex items-center gap-2 hover:text-red-400" data-testid="footer-call-link">
            <Phone size={16} className="text-red-500" /> {PHONE_DISPLAY}
          </a>
          <a href={MAP_URL} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-red-400" data-testid="footer-map-link">
            <MapPin size={16} className="text-red-500" /> {ADDRESS}
          </a>
          <div className="flex items-center gap-2">
            <Clock size={16} className="text-red-500" /> Mon–Sat: 9am–6pm · By appointment
          </div>
        </div>
        <div className="text-sm sm:text-right">
          <Link to="/inventory" className="hover:text-red-400 block mb-2" data-testid="footer-inventory-link">
            Browse Inventory
          </Link>
          <Link to="/admin/login" className="text-slate-500 hover:text-slate-300 text-xs" data-testid="footer-admin-link">
            Admin Login
          </Link>
        </div>
      </div>
      <div className="border-t border-slate-800 py-4 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Erskine Auto. All rights reserved.
      </div>
    </footer>
  );
};
